import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/lib/LangContext";

const container = { hidden: {}, visible: { transition: { staggerChildren: 0.08 } } };
const item = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.19, 1, 0.22, 1] } },
};

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section id="manifesto" className="relative py-28 lg:py-40" data-testid="manifesto-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 lg:mb-24">
          <div className="lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.28em] text-red-400 font-mono-ef">
              — {t.manifesto.overline}
            </div>
            <h2 className="mt-6 font-display font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.92] tracking-[-0.035em]">
              {t.manifesto.title}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 lg:pt-6">
            <p className="text-lg lg:text-xl text-white/70 leading-relaxed">
              {t.manifesto.subtitle}
            </p>
          </div>
        </div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-16"
        >
          {t.manifesto.chapters.map((c) => (
            <motion.article
              key={c.n}
              variants={item}
              className="relative flex flex-col gap-6 pt-8 border-t border-white/10"
            >
              <div className="flex items-baseline justify-between">
                <span className="chapter-num text-7xl lg:text-8xl">{c.n}</span>
                <span className="font-mono-ef text-[10px] text-white/40 tracking-[0.24em] uppercase">
                  chapter
                </span>
              </div>
              <h3 className="font-display text-2xl lg:text-3xl font-bold leading-tight tracking-tight">
                {c.h}
              </h3>
              <p className="text-white/60 text-base lg:text-lg leading-relaxed max-w-xl">
                {c.p}
              </p>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
